import { CaretDownOutlined } from '@ant-design/icons'
import { useRequest } from 'ahooks'
import { Dropdown, Menu } from 'antd'
import { sortBy } from 'lodash'
import moment from 'moment'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { getRiskColor, getRiskText, risks } from '@/components'
import { Report } from '@/schemas'

interface ReportRiskProps {
  report: Report
  disabled: boolean
}

export const ReportRisk: React.FC<ReportRiskProps> = ({ report, disabled }) => {
  const { t } = useTranslation()

  const [risk, setRisk] = React.useState('')

  React.useEffect(() => {
    setRisk(report.risk || '')
  }, [report.risk])

  const { run } = useRequest(
    (risk) => ({
      url: '/api/project/updateProjectReport',
      method: 'post',
      data: {
        id: report.id,
        selfId: report.selfId,
        type: report.type,
        risk,
      },
    }),
    {
      manual: true,
    }
  )

  const menu = (
    <Menu>
      {risks.map(({ value }) => (
        <Menu.Item
          key={value}
          onClick={({ key, domEvent }) => {
            domEvent.stopPropagation()
            setRisk(key)
            run(key)
          }}
        >
          {value}
        </Menu.Item>
      ))}
    </Menu>
  )

  const content = (
    <>
      {!risk ? (
        !disabled ? (
          <span>{t('风险等级')}</span>
        ) : (
          <span>{t('未填写风险')}</span>
        )
      ) : (
        <span>
          {getRiskText({ risk, t })}
          {t('风险')}
        </span>
      )}
    </>
  )

  const elm = !disabled ? (
    <Dropdown overlay={menu} trigger={['click']}>
      <span className='cursor-pointer' style={{ color: getRiskColor(risk) }} onClick={(e) => e.stopPropagation()}>
        {content}
        <CaretDownOutlined className='text-12px inline-block ml-2px' />
      </span>
    </Dropdown>
  ) : (
    <span style={{ color: getRiskColor(risk) }}>{content}</span>
  )

  return (
    <div className='flex px-6px py-2px rounded-2px' style={{ background: risk ? getRiskColor(risk) + '20' : '' }}>
      {elm}
    </div>
  )
}

export const calReportUpdateTime = (report: Report) => {
  let updatedAt = report.updatedAt
  report.extras = sortBy(report.extras, 'updatedAt')
  if (report.extras.length) {
    updatedAt = moment(updatedAt).isAfter(report.extras[report.extras.length - 1].updatedAt)
      ? updatedAt
      : report.extras[report.extras.length - 1].updatedAt
  }

  return updatedAt
}
